import { ContestStatus } from '@betterpool/api-types/contests-service';

import { CommissionerContestV2ItemSchema } from '~/services/contests/contests-v2.service.api';
import { logError } from '~/common/utils/log';
import type { MyUserContest } from '~/domains/contest/domains/myContests/types/userContest';

const V2_TO_V1_STATUS: Record<string, ContestStatus> = {
  scheduled: ContestStatus.SCHEDULED,
  in_progress: ContestStatus.IN_PROGRESS,
  finished: ContestStatus.FINISHED,
  finalized: ContestStatus.FINALIZED,
  cancelled: ContestStatus.CANCELLED,
};

const getV1Status = (isStarted: boolean, status: string): ContestStatus => {
  if (!isStarted) {
    return ContestStatus.SCHEDULED;
  }

  return V2_TO_V1_STATUS[status] ?? ContestStatus.IN_PROGRESS;
};

const parseCommissionerContestsV2 = (contests: unknown[]): MyUserContest[] =>
  contests.reduce<MyUserContest[]>((parsed, rawItem) => {
    const result = CommissionerContestV2ItemSchema.safeParse(rawItem);
    if (result.success === false) {
      logError(
        'parseCommissionerContestsV2: skipping invalid v2 contest item',
        result.error,
        rawItem
      );
      return parsed;
    }

    const item = result.data;
    const leagues = item.contest.leagues ?? [];
    const [league] = leagues;

    parsed.push({
      id: item.contest.id,
      commissioner: item.commissioner,
      league,
      leagues,
      name: item.contest.name,
      start_date: item.contest.startDate ? new Date(item.contest.startDate) : null,
      settled_date: item.contest.settledDate ? new Date(item.contest.settledDate) : undefined,
      entries: {
        filled: item.entries?.filled,
        max: item.entries?.max,
        user: item.entries?.user,
        max_per_user: item.entries?.maxPerUser,
        is_unlimited_entries: item.entries?.isUnlimitedEntries,
      },
      entry_fee: item.contest.entryFeeCents,
      prize_pool: item.contest.prizePoolCents,
      contest_type: item.contest.contestType,
      status: getV1Status(item.contest.isStarted, item.contest.status),
      missingPicksEntryIds: [],
      injuredPicksEntryIds: [],
      leaderboard: undefined,
      survivor: undefined,
      slate: undefined,
      alerts: item.alerts,
      entitySource: item.contest.entitySource,
      isEntertainmentOnly: item.contest.isEntertainmentOnly,
      game_center_url: item.urls?.gameCenterUrl,
      share_url: item.urls?.shareUrl,
      manage_contest_url: item.urls?.manageUrl,
      restart_url: item.urls?.restartUrl,
    } as unknown as MyUserContest);

    return parsed;
  }, []);

export default parseCommissionerContestsV2;
